import { buildOrgPath, PATHS } from "@constants/Paths";
import { useOptionalActiveOrganization } from "@stores/ActiveOrganizationContext";
import { useAuthContext } from "@stores/AuthContext";
import { getIsAdmin } from "@stores/utils";
/**
 * Where "back to home" goes for whoever is looking. Inside `/o/:orgId` it is that organization's
 * home, for staff as much as for members. Outside it, staff belong on the admin dashboard and a
 * member has no home to go to — the unprefixed `/home` renders Restricted by design.
 */
export const useHomeDestination = () => {
    const { user } = useAuthContext();
    const activeOrgContext = useOptionalActiveOrganization();
    if (activeOrgContext)
        return buildOrgPath(activeOrgContext.activeOrgId, PATHS.HOME);
    return getIsAdmin(user) ? PATHS.ADMIN_DASHBOARD : PATHS.RESTRICTED;
};
